export const prices = [
  {
    id: 0,
    name: {
      ru: 'Microsoft 365 Apps for Business',
      en: 'Microsoft 365 Apps for Business'
    },
    group: 'office_business',
    prices: {
      rub: 61870,
      usd: 952,
      eur: 825
    }
  },
  {
    id: 1,
    name: {
      ru: 'Microsoft 365 Business Standard',
      en: 'Microsoft 365 Business Standard'
    },
    group: 'office_business',
    prices: {
      rub: 93720,
      usd: 1442,
      eur: 1250
    }
  },
  {
    id: 2,
    name: {
      ru: 'Microsoft 365 Business Basic (бизнес базовый)',
      en: 'Microsoft 365 Business Basic'
    },
    group: 'office_business',
    prices: {
      rub: 37490,
      usd: 577,
      eur: 500
    }
  },
  {
    id: 3,
    name: {
      ru: 'Microsoft 365 Apps for Enterprise',
      en: 'Microsoft 365 Apps for Enterprise'
    },
    group: 'office_enterprise',
    prices: {
      rub: 89980,
      usd: 1384,
      eur: 1200
    }
  },
  {
    id: 4,
    name: {
      ru: 'Office 365 Enterprise E1',
      en: 'Office 365 Enterprise E1'
    },
    group: 'office_enterprise',
    prices: {
      rub: 59990,
      usd: 923,
      eur: 800
    }
  },
  {
    id: 5,
    name: {
      ru: 'Office 365 Enterprise E3',
      en: 'Office 365 Enterprise E3'
    },
    group: 'office_enterprise',
    prices: {
      rub: 149960,
      usd: 2307,
      eur: 1999
    }
  },
  {
    id: 6,
    name: {
      ru: 'Office 365 Enterprise E5',
      en: 'Office 365 Enterprise E5'
    },
    group: 'office_enterprise',
    prices: {
      rub: 262430,
      usd: 4037,
      eur: 3499
    }
  },
  {
    id: 7,
    name: {
      ru: 'Office 365 Enterprise F1',
      en: 'Office 365 Enterprise F1'
    },
    group: 'office_enterprise',
    prices: {
      rub: 29990,
      usd: 461,
      eur: 400
    }
  },
  {
    id: 8,
    name: {
      ru: 'Exchange Online (Plan 1)',
      en: 'Exchange Online (Plan 1)'
    },
    group: 'exchange',
    prices: {
      rub: 29990,
      usd: 461,
      eur: 400
    }
  },
  {
    id: 9,
    name: {
      ru: 'Exchange Online (Plan 2)',
      en: 'Exchange Online (Plan 2)'
    },
    group: 'exchange',
    prices: {
      rub: 59990,
      usd: 923,
      eur: 800
    }
  },
  {
    id: 10,
    name: {
      ru: 'Exchange Online Archiving (EOA) for Exchange Server',
      en: 'Exchange Online Archiving (EOA) for Exchange Server'
    },
    group: 'exchange',
    prices: {
      rub: 22500,
      usd: 346,
      eur: 300
    }
  },
  {
    id: 11,
    name: {
      ru: 'Skype for Business Online (Plan 1)',
      en: 'Skype for Business Online (Plan 1)'
    },
    group: 'skype',
    prices: {
      rub: 12500,
      usd: 200,
      eur: 170
    }
  },
  {
    id: 12,
    name: {
      ru: 'Skype for Business Online',
      en: 'Skype for Business Online'
    },
    group: 'skype',
    prices: {
      rub: 41240,
      usd: 634,
      eur: 550
    }
  },
  {
    id: 13,
    name: {
      ru: 'Azure Active Directory Basic',
      en: 'Azure Active Directory Basic'
    },
    group: 'azure',
    prices: {
      rub: 7500,
      usd: 115,
      eur: 100
    }
  },
  {
    id: 14,
    name: {
      ru: 'Azure Active Directory Premium P1',
      en: 'Azure Active Directory Premium P1'
    },
    group: 'azure',
    prices: {
      rub: 45000,
      usd: 692,
      eur: 600
    }
  },
  {
    id: 15,
    name: {
      ru: 'Azure Active Directory Premium P2',
      en: 'Azure Active Directory Premium P2'
    },
    group: 'azure',
    prices: {
      rub: 67490,
      usd: 1038,
      eur: 900
    }
  },
  {
    id: 16,
    name: {
      ru: 'OneDrive for Business (Plan 1)',
      en: 'OneDrive for Business (Plan 1)'
    },
    group: 'onedrive',
    prices: {
      rub: 37490,
      usd: 577,
      eur: 500
    }
  },
  {
    id: 17,
    name: {
      ru: 'OneDrive for Business (Plan 2)',
      en: 'OneDrive for Business (Plan 2)'
    },
    group: 'onedrive',
    prices: {
      rub: 75000,
      usd: 1154,
      eur: 1000
    }
  },
  {
    id: 18,
    name: {
      ru: 'Visio Online (Plan 1)',
      en: 'Visio Online (Plan 1)'
    },
    group: 'visio',
    prices: {
      rub: 37500,
      usd: 577,
      eur: 500
    }
  },
  {
    id: 19,
    name: {
      ru: 'Visio Online (Plan 2)',
      en: 'Visio Online (Plan 2)'
    },
    group: 'visio',
    prices: {
      rub: 112500,
      usd: 1731,
      eur: 1500
    }
  }
]